import { render, staticRenderFns } from "./modal_exclusao.vue?vue&type=template&id=289c40c2&scoped=true"
import script from "./modal_exclusao.vue?vue&type=script&lang=js"
export * from "./modal_exclusao.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "289c40c2",
  null
  
)

export default component.exports